<template>
  <div :key="uniqueKey" class="text"
       :class="config.jumpPanelSn ? 'has-jump':''"
       :style="{
         textAlign: config.chartSet.titleStyle.align,
         fontSize: config.chartSet.titleStyle.fontSize + 'px',
         color: config.chartSet.titleStyle.color
       }">
    <img v-if="borderImgUrl" class="text-border" :src="borderImgUrl" alt=""
         :style="{
           display:'inline-block',
           width:'100%',
           height: '100%'
         }">
    <div class="text-block" :style="{lineHeight: config.chartHeight+ 'px'}">
      {{ config.chartTitle }}
    </div>
  </div>
</template>

<script>
import { imgURLtoBase64 } from '@/utils/common'

export default {
  name: 'TextBlock',
  props: {
    config: {
      type: Object,
    },
    globalConfig: {
      type: Object,
    },
    componentType: {
      type: String,
    },
  },
  data () {
    return {
      borderImgUrl: '',
      uniqueKey: 'xxx',

    }
  },
  computed: {
    borderStyle () {
      return this.config.chartSet.borderStyle.borderTemplate
    },
  },
  watch: {
    async borderStyle (val) {
      if (val) {
        this.borderImgUrl = await imgURLtoBase64(val)
      } else {
        this.borderImgUrl = ''
      }
    },

  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      if (this.borderStyle) {
        this.borderImgUrl = await imgURLtoBase64(this.borderStyle)
      }
      this.uniqueKey = Math.random()
    },
  },
}
</script>

<style lang="scss" scoped>
.text {
  position: relative;
  width: 100%;
  &.has-jump{
    cursor: pointer;
  }
  &-border {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .text-block{
    cursor: inherit;
    padding: 0 30px;
  }
}

</style>
